/**
 * NativeWaves Content API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class AudioObjectsApi extends runtime.BaseAPI {
    /**
     * Delete an audio blob.
     */
    async audiosAudioIdBlobsBlobIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdBlobsBlobIdDelete.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling audiosAudioIdBlobsBlobIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}/blobs/{blobId}`
                .replace(`{${'audioId'}}`, String(requestParameters.audioId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an audio blob.
     */
    async audiosAudioIdBlobsBlobIdDelete(requestParameters, initOverrides) {
        await this.audiosAudioIdBlobsBlobIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an audio blob.
     */
    async audiosAudioIdBlobsBlobIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdBlobsBlobIdGet.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling audiosAudioIdBlobsBlobIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}/blobs/{blobId}`
                .replace(`{${'audioId'}}`, String(requestParameters.audioId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an audio blob.
     */
    async audiosAudioIdBlobsBlobIdGet(requestParameters, initOverrides) {
        const response = await this.audiosAudioIdBlobsBlobIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get an audio blob media info.
     */
    async audiosAudioIdBlobsBlobIdMediaInfoGetRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdBlobsBlobIdMediaInfoGet.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling audiosAudioIdBlobsBlobIdMediaInfoGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}/blobs/{blobId}/mediaInfo`
                .replace(`{${'audioId'}}`, String(requestParameters.audioId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an audio blob media info.
     */
    async audiosAudioIdBlobsBlobIdMediaInfoGet(requestParameters, initOverrides) {
        const response = await this.audiosAudioIdBlobsBlobIdMediaInfoGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an audio blob media info.
     */
    async audiosAudioIdBlobsBlobIdMediaInfoPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdBlobsBlobIdMediaInfoPatch.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling audiosAudioIdBlobsBlobIdMediaInfoPatch.');
        }
        if (requestParameters.aVMediaInfo === null ||
            requestParameters.aVMediaInfo === undefined) {
            throw new runtime.RequiredError('aVMediaInfo', 'Required parameter requestParameters.aVMediaInfo was null or undefined when calling audiosAudioIdBlobsBlobIdMediaInfoPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}/blobs/{blobId}/mediaInfo`
                .replace(`{${'audioId'}}`, String(requestParameters.audioId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.aVMediaInfo,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an audio blob media info.
     */
    async audiosAudioIdBlobsBlobIdMediaInfoPatch(requestParameters, initOverrides) {
        const response = await this.audiosAudioIdBlobsBlobIdMediaInfoPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an audio blob.
     */
    async audiosAudioIdBlobsBlobIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdBlobsBlobIdPatch.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling audiosAudioIdBlobsBlobIdPatch.');
        }
        if (requestParameters.audioBlobEdit === null ||
            requestParameters.audioBlobEdit === undefined) {
            throw new runtime.RequiredError('audioBlobEdit', 'Required parameter requestParameters.audioBlobEdit was null or undefined when calling audiosAudioIdBlobsBlobIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}/blobs/{blobId}`
                .replace(`{${'audioId'}}`, String(requestParameters.audioId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.audioBlobEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an audio blob.
     */
    async audiosAudioIdBlobsBlobIdPatch(requestParameters, initOverrides) {
        const response = await this.audiosAudioIdBlobsBlobIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrigger analysis of a audio blob.
     */
    async audiosAudioIdBlobsBlobIdReanalyzePostRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdBlobsBlobIdReanalyzePost.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling audiosAudioIdBlobsBlobIdReanalyzePost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}/blobs/{blobId}/reanalyze`
                .replace(`{${'audioId'}}`, String(requestParameters.audioId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Retrigger analysis of a audio blob.
     */
    async audiosAudioIdBlobsBlobIdReanalyzePost(requestParameters, initOverrides) {
        await this.audiosAudioIdBlobsBlobIdReanalyzePostRaw(requestParameters, initOverrides);
    }
    /**
     * Edit an audio blob status (media info and alerts).
     */
    async audiosAudioIdBlobsBlobIdStatusPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdBlobsBlobIdStatusPatch.');
        }
        if (requestParameters.blobId === null ||
            requestParameters.blobId === undefined) {
            throw new runtime.RequiredError('blobId', 'Required parameter requestParameters.blobId was null or undefined when calling audiosAudioIdBlobsBlobIdStatusPatch.');
        }
        if (requestParameters.aVMediaInfoContentBlobStatus === null ||
            requestParameters.aVMediaInfoContentBlobStatus === undefined) {
            throw new runtime.RequiredError('aVMediaInfoContentBlobStatus', 'Required parameter requestParameters.aVMediaInfoContentBlobStatus was null or undefined when calling audiosAudioIdBlobsBlobIdStatusPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}/blobs/{blobId}/status`
                .replace(`{${'audioId'}}`, String(requestParameters.audioId))
                .replace(`{${'blobId'}}`, String(requestParameters.blobId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.aVMediaInfoContentBlobStatus,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an audio blob status (media info and alerts).
     */
    async audiosAudioIdBlobsBlobIdStatusPatch(requestParameters, initOverrides) {
        const response = await this.audiosAudioIdBlobsBlobIdStatusPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of blobs of an audio object.
     */
    async audiosAudioIdBlobsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdBlobsGet.');
        }
        const queryParameters = {};
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}/blobs`.replace(`{${'audioId'}}`, String(requestParameters.audioId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of blobs of an audio object.
     */
    async audiosAudioIdBlobsGet(requestParameters, initOverrides) {
        const response = await this.audiosAudioIdBlobsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new audio blob.
     */
    async audiosAudioIdBlobsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdBlobsPost.');
        }
        if (requestParameters.audioBlobInsert === null ||
            requestParameters.audioBlobInsert === undefined) {
            throw new runtime.RequiredError('audioBlobInsert', 'Required parameter requestParameters.audioBlobInsert was null or undefined when calling audiosAudioIdBlobsPost.');
        }
        const queryParameters = {};
        if (requestParameters.customId !== undefined) {
            queryParameters['customId'] = requestParameters.customId;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}/blobs`.replace(`{${'audioId'}}`, String(requestParameters.audioId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.audioBlobInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new audio blob.
     */
    async audiosAudioIdBlobsPost(requestParameters, initOverrides) {
        const response = await this.audiosAudioIdBlobsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an audio object.
     */
    async audiosAudioIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}`.replace(`{${'audioId'}}`, String(requestParameters.audioId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an audio object.
     */
    async audiosAudioIdDelete(requestParameters, initOverrides) {
        await this.audiosAudioIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get audio object details.
     */
    async audiosAudioIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}`.replace(`{${'audioId'}}`, String(requestParameters.audioId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get audio object details.
     */
    async audiosAudioIdGet(requestParameters, initOverrides) {
        const response = await this.audiosAudioIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit audio object details.
     */
    async audiosAudioIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdPatch.');
        }
        if (requestParameters.audioObjectEdit === null ||
            requestParameters.audioObjectEdit === undefined) {
            throw new runtime.RequiredError('audioObjectEdit', 'Required parameter requestParameters.audioObjectEdit was null or undefined when calling audiosAudioIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}`.replace(`{${'audioId'}}`, String(requestParameters.audioId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.audioObjectEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit audio object details.
     */
    async audiosAudioIdPatch(requestParameters, initOverrides) {
        const response = await this.audiosAudioIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of audio uploads.
     */
    async audiosAudioIdUploadsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdUploadsGet.');
        }
        const queryParameters = {};
        if (requestParameters.blobId !== undefined) {
            queryParameters['blobId'] = requestParameters.blobId;
        }
        if (requestParameters.includeClosed !== undefined) {
            queryParameters['includeClosed'] = requestParameters.includeClosed;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}/uploads`.replace(`{${'audioId'}}`, String(requestParameters.audioId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of audio uploads.
     */
    async audiosAudioIdUploadsGet(requestParameters, initOverrides) {
        const response = await this.audiosAudioIdUploadsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new audio upload.
     */
    async audiosAudioIdUploadsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdUploadsPost.');
        }
        if (requestParameters.audioUploadInsert === null ||
            requestParameters.audioUploadInsert === undefined) {
            throw new runtime.RequiredError('audioUploadInsert', 'Required parameter requestParameters.audioUploadInsert was null or undefined when calling audiosAudioIdUploadsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}/uploads`.replace(`{${'audioId'}}`, String(requestParameters.audioId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.audioUploadInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new audio upload.
     */
    async audiosAudioIdUploadsPost(requestParameters, initOverrides) {
        const response = await this.audiosAudioIdUploadsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an audio upload.
     */
    async audiosAudioIdUploadsUploadIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdUploadsUploadIdDelete.');
        }
        if (requestParameters.uploadId === null ||
            requestParameters.uploadId === undefined) {
            throw new runtime.RequiredError('uploadId', 'Required parameter requestParameters.uploadId was null or undefined when calling audiosAudioIdUploadsUploadIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}/uploads/{uploadId}`
                .replace(`{${'audioId'}}`, String(requestParameters.audioId))
                .replace(`{${'uploadId'}}`, String(requestParameters.uploadId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an audio upload.
     */
    async audiosAudioIdUploadsUploadIdDelete(requestParameters, initOverrides) {
        await this.audiosAudioIdUploadsUploadIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an audio upload.
     */
    async audiosAudioIdUploadsUploadIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.audioId === null ||
            requestParameters.audioId === undefined) {
            throw new runtime.RequiredError('audioId', 'Required parameter requestParameters.audioId was null or undefined when calling audiosAudioIdUploadsUploadIdGet.');
        }
        if (requestParameters.uploadId === null ||
            requestParameters.uploadId === undefined) {
            throw new runtime.RequiredError('uploadId', 'Required parameter requestParameters.uploadId was null or undefined when calling audiosAudioIdUploadsUploadIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios/{audioId}/uploads/{uploadId}`
                .replace(`{${'audioId'}}`, String(requestParameters.audioId))
                .replace(`{${'uploadId'}}`, String(requestParameters.uploadId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an audio upload.
     */
    async audiosAudioIdUploadsUploadIdGet(requestParameters, initOverrides) {
        const response = await this.audiosAudioIdUploadsUploadIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of audio object details. If objects belong to a stream they are not listed.
     */
    async audiosGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.repositoryId !== undefined) {
            queryParameters['repositoryId'] = requestParameters.repositoryId;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.groups) {
            queryParameters['groups'] = requestParameters.groups;
        }
        if (requestParameters.excludeGrouped !== undefined) {
            queryParameters['excludeGrouped'] = requestParameters.excludeGrouped;
        }
        if (requestParameters.timeRangeStart !== undefined) {
            queryParameters['timeRangeStart'] = requestParameters.timeRangeStart;
        }
        if (requestParameters.timeRangeEnd !== undefined) {
            queryParameters['timeRangeEnd'] = requestParameters.timeRangeEnd;
        }
        if (requestParameters.sortByTime !== undefined) {
            queryParameters['sortByTime'] = requestParameters.sortByTime;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        if (requestParameters.owner !== undefined) {
            queryParameters['owner'] = requestParameters.owner;
        }
        if (requestParameters.prefix !== undefined) {
            queryParameters['prefix'] = requestParameters.prefix;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of audio object details. If objects belong to a stream they are not listed.
     */
    async audiosGet(requestParameters = {}, initOverrides) {
        const response = await this.audiosGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new audio object.
     */
    async audiosPostRaw(requestParameters, initOverrides) {
        if (requestParameters.audioObjectInsert === null ||
            requestParameters.audioObjectInsert === undefined) {
            throw new runtime.RequiredError('audioObjectInsert', 'Required parameter requestParameters.audioObjectInsert was null or undefined when calling audiosPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/audios`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.audioObjectInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new audio object.
     */
    async audiosPost(requestParameters, initOverrides) {
        const response = await this.audiosPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const AudiosAudioIdBlobsGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const AudiosGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const AudiosGetSortByTimeEnum = {
    Desc: 'Desc',
    Asc: 'Asc',
};
//# sourceMappingURL=AudioObjectsApi.js.map